import { render } from "./BaseSelectImage.vue?vue&type=template&id=0782645c&scoped=true&lang=pug"
import script from "./BaseSelectImage.vue?vue&type=script&lang=js"
export * from "./BaseSelectImage.vue?vue&type=script&lang=js"

import "./BaseSelectImage.vue?vue&type=style&index=0&id=0782645c&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0782645c"]])

export default __exports__